export function showFrontChat(
  customFields: Record<
    string,
    string | number | boolean | undefined | null
  > = {}
) {
  if (window.FrontChat && import.meta.env.VITE_FRONT_CHAT_ID) {
    window.FrontChat('identity', { customFields });
    window.FrontChat('show');
  }
}
